import { createFileRoute } from "@tanstack/react-router";
import { breadcrumbJsonLd } from "@/lib/breadcrumb-jsonld";
import { Header } from "@/components/site/Header";
import { About } from "@/components/site/About";
import { ContactDetailsCards } from "@/components/site/ContactDetailsCards";
import { Footer } from "@/components/site/Footer";

export const Route = createFileRoute("/over-ons")({
  head: () => ({
    meta: [
      { title: "Over ons — Elvion Group Nederland helpt u graag verder" },
      {
        name: "description",
        content:
          "Maak kennis met Elvion Group Nederland: een krachtige organisatie van gespecialiseerde technische ondernemingen. Wij helpen u graag verder — particulier én zakelijk.",
      },
      { property: "og:title", content: "Over Elvion Group Nederland" },
      { property: "og:description", content: "Lees wie Elvion Group Nederland is, waar wij gevestigd zijn en hoe wij klanten helpen met producten, installatie en service." },
      { property: "og:url", content: "https://elvion-group.nl/over-ons" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "Over Elvion Group Nederland" },
      { name: "twitter:description", content: "Bedrijfsidentiteit, werkwijze en service van Elvion Group Nederland." },
    ],
    links: [{ rel: "canonical", href: "https://elvion-group.nl/over-ons" }],
    scripts: [breadcrumbJsonLd([{ name: "Over ons", path: "/over-ons" }])],
  }),
  component: OverOnsPage,
});

function OverOnsPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header variant="shop" />
      <main>
        <h1 className="sr-only">Over Elvion Group Nederland — wij helpen u graag verder</h1>
        <About />
        <ContactDetailsCards />
      </main>
      <Footer />
    </div>
  );
}
